;(function () {
  'use strict'

  angular.module('contrast.auth').factory('LoginService', [LoginService])

  function LoginService() {
    var _isAfterFirstLogin

    var service = {
      isAfterFirstLogin: isAfterFirstLogin,
      setIsAfterFirstLogin: setIsAfterFirstLogin
    }

    return service

    function setIsAfterFirstLogin(bool) {
      _isAfterFirstLogin = bool
    }

    function isAfterFirstLogin() {
      return _isAfterFirstLogin
    }
  }
})()
